module.exports = __webpack_public_path__ + "static/bristol-city-1ae90d8c51045703c45fff23c865cabf.svg";